import { CraftingResolverService } from '../../services/craftingResolver';

let sharedResolver: CraftingResolverService | null = null;
let sharedResolverPromise: Promise<CraftingResolverService> | null = null;

export function getSharedResolver(): Promise<CraftingResolverService> {
    if (sharedResolver) return Promise.resolve(sharedResolver);
    if (!sharedResolverPromise) {
        sharedResolverPromise = (async () => {
            const r = new CraftingResolverService();
            await r.initialize();
            sharedResolver = r;
            return r;
        })();
    }
    return sharedResolverPromise;
}
